export default function Container(theme: any) {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: "none !important",
        },
      },
    },
  };
}
